<template>
  <v-layout v-resize="onResize" column style="padding-top: 56px">
    <!-- <div v-if="isLoading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div> -->
    <v-data-table
      flat
      :headers="headers"
      :items="payments"
      :loading="isLoading"
      click:row
      :rows-per-page-items="limitOptions"
      class="elevation-2"
      :hide-headers="isMobile"
      :class="{ mobile: isMobile }"
      :pagination.sync="pagination"
      :total-items="total"
    >
      <template slot="items" slot-scope="sales">
        <tr v-if="!isMobile">
          <td class="text-xs-left">
            {{ $d(new Date(sales.item.created_at), "dateAndTime") }}
          </td>
          <td class="text-xs-left">{{ $n(sales.item.amount, "currency") }}</td>
          <td class="text-xs-left">
            {{ $n(sales.item.fees_amount, "currency") }}
          </td>
          <td class="text-xs-left">
            {{ $n(sales.item.amount_for_seller, "currency") }}
          </td>
          <td class="text-xs-left">
            {{ sales.item.credit === true ? "Crédito" : "Débito" }}
          </td>
          <td class="text-xs-left">
            {{
              $d(
                new Date(getDueDate(sales.item.due_on, sales.item.credit)),
                "short"
              )
            }}
          </td>
          <td class="text-xs-left">
            <payment-brand :brand="sales.item.credit_card_brand" :size="32" />
          </td>
          <td class="text-xs-left">{{ sales.item.installments }}</td>
          <td class="text-xs-left">
            <v-chip
              :class="chipClass(sales.item.status)"
              small
              text-color="white"
            >
              {{ $t(`status.${sales.item.status}`) }}
            </v-chip>
          </td>
          <td v-if="sales.item.nsu_acquirer === null" class="text-xs-left">
            -
          </td>
          <td v-else class="text-xs-left">{{ sales.item.nsu_acquirer }}</td>
          <td v-if="sales.item.terminal_number === null" class="text-xs-left">
            -
          </td>
          <td v-else class="text-xs-left">{{ sales.item.terminal_number }}</td>
          <td class="text-xs-left">{{ sales.item.authorization_code }}</td>
          <td class="text-xs-center">
            <router-link
              :to="{ name: 'payment', params: { id: sales.item.id } }"
              >Exibir</router-link
            >
          </td>
          <td style="display: none"></td>
        </tr>
        <tr v-else>
          <td>
            <ul class="flex-content">
              <li class="flex-item" data-label="Efetuado em">
                {{ $d(new Date(sales.item.created_at), "short") }}
              </li>
              <li class="flex-item" data-label="Valor">
                {{ $n(sales.item.amount, "currency") }}
              </li>
              <li class="flex-item" data-label="Tarifa">
                {{ $n(sales.item.fees_amount, "currency") }}
              </li>
              <li class="flex-item" data-label="À receber">
                {{ $n(sales.item.amount_for_seller, "currency") }}
              </li>
              <li class="flex-item" data-label="Pagamento">
                {{ sales.item.credit === true ? "Crédito" : "Débito" }}
              </li>
              <li class="flex-item" data-label="Depósito em">
                {{
                  $d(
                    new Date(getDueDate(sales.item.due_on, sales.item.credit)),
                    "short"
                  )
                }}
              </li>
              <li class="flex-item" data-label="Bandeira">
                <payment-brand :brand="sales.item.credit_card_brand" :size="28" />
              </li>
              <li class="flex-item" data-label="Parcelas">
                {{ sales.item.installments }}
              </li>
              <li class="flex-item" data-label="Status">
                <v-chip
                  :class="chipClass(sales.item.status)"
                  small
                  text-color="white"
                >
                  {{ $t(`status.${sales.item.status}`) }}
                </v-chip>
              </li>
              <li
                v-if="sales.item.nsu_acquirer === null"
                class="flex-item"
                data-label="NSU"
              >
                -
              </li>
              <li v-else class="flex-item" data-label="NSU">
                {{ sales.item.nsu_acquirer }}
              </li>
              <li
                v-if="sales.item.terminal_number === null"
                class="flex-item"
                data-label="Número do Terminal"
              >
                -
              </li>
              <li v-else class="flex-item" data-label="Número do Terminal">
                {{ sales.item.terminal_number }}
              </li>
              <li class="flex-item" data-label="Autorização">
                {{ sales.item.authorization_code }}
              </li>
              <li class="flex-item" data-label="Detalhes">
                <router-link
                  :to="{ name: 'payment', params: { id: sales.item.id } }"
                  >Exibir</router-link
                >
              </li>
              <li style="display: none"></li>
            </ul>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";

export default {
  created() {
    this.$store.dispatch("payments/load");
  },
  components: {
    PaymentBrand: () => import("@/components/desktop/brand/PaymentBrand.vue"),
  },
  computed: {
    ...mapGetters({
      payments: "payments/list",
      limit: "payments/limit",
      page: "payments/page",
      total: "payments/totalResources",
      limitOptions: "payments/limitOptions",
      showFilters: "payments/showFilters",
      filterParams: "payments/filterParams",
      isLoading: "payments/loadingData",
    }),
  },
  methods: {
    ...mapActions({
      setCurrentPage: "payments/setCurrentPage",
      setLimit: "payments/setLimit",
    }),
    chipClass(status) {
      return `payment ${status}`;
    },
    getDueDate(dueDate, kind) {
      if (kind) {
        return dueDate;
      } else {
        dueDate = new Date(dueDate).setDate(new Date(dueDate).getDate() + 1);
        return dueDate;
      }
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },

  data() {
    return {
      items: [],
      count: 0,
      pagination: {},
      duedate: "",
      isMobile: false,
      headers: [
        { text: this.$t("phrases.doneIn"), value: "efetuado em" },
        { text: this.$t("words.value"), value: "value" },
        { text: this.$t("words.rates"), value: "rates" },
        { text: this.$t("phrases.toReceive"), value: "toReceive" },
        { text: this.$t("words.payment"), value: "payment" },
        { text: this.$t("phrases.depositIn"), value: "depositIn" },
        { text: this.$t("words.cardBrand"), value: "cardBrand" },
        { text: this.$t("words.installment"), value: "installment" },
        { text: this.$t("status.status"), value: "status.status" },
        { text: "nsu", value: "nsu_acquirer" },
        { text: this.$t("phrases.terminalNumber"), value: "terminal_number" },
        { text: this.$t("words.authorization"), value: "authorization_code" },
        { text: this.$t("words.detail"), value: "detail" },
      ],
    };
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch("payments/load", this.filterParams);
      }
      if (changed(newPagination.page, oldPagination.page)) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch("payments/load", this.filterParams);
      }
    }
  }
};
</script>
  <style>
.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid #b2b2b8;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid #636366;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
  margin-top: 10px;
}
.v-chip.payment.all {
  background-color: #757575 !important;
}
.v-chip.payment.waiting {
  background-color: #546e7a !important;
}
.v-chip.payment.processing {
  background-color: #546e7a !important;
}
.v-chip.payment.approved {
  background-color: #33691e !important;
}
.v-chip.payment.cancelled {
  background-color: #b71c1c !important;
}
.v-chip.payment.completed {
  background-color: #1b5e20 !important;
}
.v-chip.payment.failed {
  background-color: #e53935 !important;
}
.v-chip.payment.refunded {
  background-color: #ef6c00 !important;
}
.v-chip.payment.anticipated {
  background-color: #006064 !important;
}
</style>
